export * from "./favorites-skeleton.component";
